import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {FormControl} from "@angular/forms";
import {StickerSheetsListComponent} from "../../components/sticker-sheets-list/sticker-sheets-list.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {ActivatedRoute, Router} from "@angular/router";
import {MedicineStickersService} from "../../services/medicine-stickers.service";
import {MessageType} from "../../../shared/redux-store/session";
import {FileService} from "../../../core/visbos-core/http/file.service";

@Component({
  selector: 'vb-sticker-sheets-view',
  templateUrl: './sticker-sheets-view.component.html',
  styleUrls: ['./sticker-sheets-view.component.css']
})
export class StickerSheetsViewComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit {

  searchTerm: FormControl = new FormControl();

  @ViewChild('stickerSheetsList')
  stickerSheetsList: StickerSheetsListComponent;

  selectedSheets = [];

  trainingMode: boolean = false;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private router: Router, private route: ActivatedRoute,
              private medService: MedicineStickersService, private fileService: FileService) {
    super(sessionActions, cd);

    this.actions = [
      {label: 'Neuen Druckbogen anlegen', icon: 'fa-plus', action: () => this.onAddClicked.apply(this)},
      {
        label: 'Mehrere auf eine Seite',
        helpText: 'Generiert aus den ausgewählten individuellen Druckbögen eine PDF-Datei, die bis zu 4 Druckbögen auf einer einzelnen Eteikettenbogen-Seite darstellt.',
        icon: 'fa-print',
        disabled: () => !this.canPrintMultiple.apply(this),
        action: () => this.onPrintMultipleClicked.apply(this)
      }
    ];

  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.actions.concat(this.stickerSheetsList.actions);
    this.dataObservables.concat(this.stickerSheetsList.getComponentData());
  }

  onAddClicked() {
    this.router.navigate(['./neu'], {relativeTo: this.route});
  }

  onPrintMultipleClicked() {
    this.sessionActions.pushMessage("Druckbogen wird erzeugt, Sie werden benachrichtigt, sobald die PDF-Datei verfügbar ist. Dies kann einige Sekunden dauern...", MessageType.INFO, "Spritzenetiketten");

    this.medService.generateCustomStickersSheetPdf(this.selectedSheets.map(s => s.cuid), true, this.trainingMode).subscribe(
      res => {
        let data = this.fileService.base64toBlob(res.data.customStickerSheetsPdf, 'application/pdf', 512);
        this.fileService.saveAs(data, 'spritzenetiketten.pdf');
      }, err => this.sessionActions.throwError(err)
    );
  }

  canPrintMultiple() {
    return this.selectedSheets && this.selectedSheets.length > 1;
  }

}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/view-components/sticker-sheets-view/sticker-sheets-view.component.ts